import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseService } from 'projects/assist/src/app/_shared/services/base.service';
import { Observable } from 'rxjs';
import { Payment, PaymentList } from '../../member/models/payment';

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService<Payment, PaymentList> {
  constructor(
    protected override http: HttpClient,
    @Inject('BASE_URL') protected override baseUrl: string
  ) {
    super(http, baseUrl, 'payment');
  }

  check(paymentKey: string): Observable<Payment> {
    return this.get('/check?accessKey=' + paymentKey);
  }

  getByTicket(ticketId: number | null, accessKey: string): Observable<Payment> {
    return this.get('/byTicket/' + ticketId + '?accessKey=' + accessKey);
  }
}
